import NinjaTable from 'components/tables/NinjaTable';
import React from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import Widget from 'components/Widget/Widget';
import { JustValueFormatter } from 'components/tables/NinjaTable/formatters';
import { TotalValueFormatter } from 'components/tables/NinjaTable/formatters';
import { CountryFormatter } from 'modules/CRMModule/formatters';
import ValueFormatter from 'components/table-formatters/values/ValueFormatter';
import { NameDefinition } from 'components/NameDefinition';
import { useWidget } from 'components/Widget/useWidget';

const SalesByCountryTable = ({ height, index }) => {
  const { filters } = useWidget();
  const { dates } = useWidgetDate('product_sales' + index);

  const columns = [
    {
      key: 'country',
      name: 'Country',
      sortable: true,
      renderCell: ({ row }) =>
        row.country ? <CountryFormatter value={row.country} editable={false} /> : 'N/A',
      renderSummaryCell: () => 'Totals',
    },
    {
      key: 'gross_income',
      type: 'income',
      name: <NameDefinition name='Gross Income' definition='Total of all product prices' />,
      renderCell: JustValueFormatter,
      renderSummaryCell: JustValueFormatter,
      sortable: true,
      resizable: true,
      minWidth: 100,
    },
    {
      key: 'gross_profit',
      name: (
        <NameDefinition
          name='Gross Profit'
          definition='Gross profit: The total profit from all products sold, minus the profit lost from canceled products.'
        />
      ),
      minWidth: 100,
      sortable: true,
      renderCell: JustValueFormatter,
      renderSummaryCell: TotalValueFormatter,
    },
    {
      key: 'orders_count',
      name: <NameDefinition name='Orders Count' definition='Number of orders.' />,
      sortable: true,
      renderCell: ValueFormatter,
      renderSummaryCell: ValueFormatter,
    },
  ];
  return (
    <NinjaTable
      columns={columns}
      dataProvider='integrationSalesByCountry'
      queryParams={{ ...dates, ...filters }}
      cardProps={{ disable: true }}
      maxHeight={height}
      footerProps={{ readOnlyPagination: true }}
      tableProps={{ template: 'widget' }}
      defaultSortColumns={{ columnKey: 'gross_income', direction: 'DESC' }}
    />
  );
};

export default SalesByCountryTable;
